/**
 * The SPA's mount path. Single source of truth consumed by BrowserRouter
 * (App.tsx) and by the auth layer's router-path derivation (AuthProvider's
 * currentRouterPath) — keep all basename knowledge here.
 */
export const APP_BASENAME = '/AITA';
